module.exports = __webpack_public_path__ + "img/imagineRIT.a592e961.png";